import { GrammarHighlighter } from './grammar-highlighter.js';

const GRAMMAR_READY_ATTR = 'data-grammar-highlighter-ready';

// Keep constructor accessible for pages that instantiate highlighters manually.
window.GrammarHighlighter = GrammarHighlighter;

export function initGrammarHighlighters() {
    const syntaxDivs = document.querySelectorAll('.syntax');

    syntaxDivs.forEach((div, index) => {
        if (div.hasAttribute(GRAMMAR_READY_ATTR)) {
            return;
        }

        try {
            const highlighter = new GrammarHighlighter(div, {
                matchMode: 'token',
                iouThreshold: 0.9
            });
            highlighter.loadFromMarkedHTML(div.innerHTML);
            div.setAttribute(GRAMMAR_READY_ATTR, 'true');
            console.log('[grammar] initialized', { index });
        } catch (error) {
            console.error('[grammar] initialization failed', { index, error });
        }
    });
}
